/**
 * Pre-check: does the customer object have loyalty data for this site?
 * This is a fast, synchronous check from c_acLoyaltyData — no API call.
 *
 * @param {string|undefined} acLoyaltyDataStr - customer.c_acLoyaltyData (JSON string)
 * @param {string} siteId - e.g. 'FSASTORE', 'HSASTORE', 'WDH'
 * @returns {{ hasData: boolean, loyaltyData: object|null }}
 */
export const getLoyaltyEnrollment = (acLoyaltyDataStr, siteId) => {
    if (!acLoyaltyDataStr || !siteId) return {hasData: false, loyaltyData: null}
    try {
        const parsed = JSON.parse(acLoyaltyDataStr)
        const siteData = parsed[siteId]
        return siteData
            ? {hasData: true, loyaltyData: siteData}
            : {hasData: false, loyaltyData: null}
    } catch {
        return {hasData: false, loyaltyData: null}
    }
}
